import React from 'react';
import PropTypes from 'prop-types';
import parseUrl from 'video-service-url-parser';
import { SOURCE_YOUTUBE, SOURCE_VIMEO } from './Constants';
import DefaultVideo from './DefaultVideo';
import Vimeo from './Vimeo';
import YouTube from './YouTube';

export default class VideoComponent extends React.Component {
    static propTypes = {
        autoplay: PropTypes.bool,
        disabled: PropTypes.bool,
        dimensions: PropTypes.shape({
            h: PropTypes.number.isRequired,
            w: PropTypes.number.isRequired,
        }),
        onSubmit: PropTypes.func,
        videoUrl: PropTypes.string.isRequired,
        description: PropTypes.string,
        onStatusChange: PropTypes.func,
    };

    static defaultProps = {
        dimensions: { h: 335, w: 640 },
    };

    _onPlay = (source) => {
        if (this.props.onStatusChange) {
            this.props.onStatusChange(source, 'play-video');
        }
    };

    _onPause = (source) => {
        if (this.props.onStatusChange) {
            this.props.onStatusChange(source, 'pause-video');
        }
    };

    _onEnd = (source) => {
        if (this.props.onStatusChange) {
            this.props.onStatusChange(source, 'end-video');
        }
    };

    render() {
        let videoContainer;
        const videoProps = {
            url: this.props.videoUrl,
            dimensions: this.props.dimensions,
            description: this.props.description,
            autoplay: this.props.autoplay,
            onPlay: this._onPlay,
            onPause: this._onPause,
            onEnd: this._onEnd,
            onSubmit: this.props.onSubmit,
            disabled: this.props.disabled,
        };

        const { service } = parseUrl(this.props.videoUrl);
        if (service === SOURCE_YOUTUBE) {
            videoContainer = (
                <YouTube {...videoProps}>{this.props.children}</YouTube>
            );
        } else if (service === SOURCE_VIMEO) {
            videoContainer = (
                <Vimeo {...videoProps}>{this.props.children}</Vimeo>
            );
        } else {
            videoContainer = <DefaultVideo {...videoProps} />;
        }

        return videoContainer;
    }
}
